import {getHelpActionTypes} from './actionTypes'

export function toggle(newState) {
    return {
        type: getHelpActionTypes.TOGGLE,
        payload: newState
    }
}
